import { PropsWithChildren, ReactNode } from 'react';
import classnames from 'classnames';
import { MdOutlineWarning } from 'react-icons/md';
import { Tooltip } from '@ds';

const WARNING_ICON_SIZE = 16;

type ResourceCardProps = PropsWithChildren<{
  hasWarning?: boolean;
  className?: string;
}>;

export const ResourceCard = ({ hasWarning = false, className, children }: ResourceCardProps) => (
  <div
    className={classnames(
      'relative flex w-48 p-2 rounded-lg items-center overflow-hidden',
      hasWarning ? 'bg-warning-80' : 'bg-base-80',
      className,
    )}
  >
    {children}
  </div>
);

type ResourceCardTextProps = {
  title: ReactNode;
  subTitle: ReactNode;
  titleAdornment?: ReactNode;
};

export const ResourceCardText = ({ title, subTitle, titleAdornment }: ResourceCardTextProps) => (
  <div className="flex flex-col">
    <div className="flex gap-1 items-center">
      <span className="text-s-sb text-black truncate max-w-32">{title}</span>
      {titleAdornment}
    </div>
    <span className="text-s-r text-base-10 truncate max-w-36">{subTitle}</span>
  </div>
);

type ResourceWarningTooltipProps = {
  content: ReactNode;
  className?: string;
};

export const ResourceWarningTooltip = ({ content, className }: ResourceWarningTooltipProps) => (
  <Tooltip content={content} className="max-w-70">
    <div className={className}>
      <MdOutlineWarning size={WARNING_ICON_SIZE} className="text-warning-40 cursor-pointer" />
    </div>
  </Tooltip>
);
